import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";

import Slider from "react-slick";
import facilityImages from '../../../../../data/facilityImages.json';
import { Box } from "@mui/material";

export default function MobileFacilityImageCarousel() {
  const settings = {
  dots: false,
  infinite: true,
  slidesToShow: 1,
  slidesToScroll: 1,
  speed: 1200,
  autoplay: true,
  autoplaySpeed: 3000,
  cssEase: "ease-in-out"
};

  return (
    <Box
      sx={{
                    position: 'absolute',
                    top: 0,
                    left: 0,
                    width: '100%',
                    height: '100%',
                    overflowY: 'hidden',
                    backgroundColor:'secondary.main',
                    zIndex: 0,
                }}
    >
       <Slider {...settings}>
    {facilityImages.map((src, i) => (
      <div key={i}>
        <div
          style={{
            height: "600px",
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
          }}
        >
          <img
            src={src}
            alt={`facility-${i}`}
            style={{
              maxHeight: "100%",
              maxWidth: "100%",
              objectFit: "contain"
            }}
          />
        </div>
      </div>
      ))}
    </Slider>
    </Box>
  );
}